import { db } from '../firebaseConfig';
import { doc, setDoc, getDoc, updateDoc, Timestamp } from "firebase/firestore";
import { uploadFileToAws, getFileUrl, deleteFile, listFiles } from '../minioConfig';
import html2canvas from 'html2canvas';
import imageCompression from 'browser-image-compression';
import { Popup, Icon } from 'semantic-ui-react';
import moment from "moment/moment";

const updateUserTokenCount = async (userId, tokenCount) => {
    try {
        const tokenDocRef = doc(db, 'users', userId);

        // Set the token count in the user's document
        // If the document does not exist, it will be created
        await setDoc(tokenDocRef, { tokenCount }, { merge: true });

        console.log("Document written or updated");
        return true; // Success indicator
    } catch (error) {
        console.error('Error updating token count:', error);
        return false; // Failure indicator
    }
};
function interpolateTemplate(templateString, values) {
    return templateString.replace(
        /\$\[(?<arrayKey>[^\]]+?)(?:,\s*"(?<mapParam>(?:(?:\$(?<conditionDelimiterInArray>\?+)\[(?:[^\],]+),\s*"(?:[^"]+)",\s*"(?:(?:[^\?]|\k<conditionDelimiterInArray>\?+\[|\]\k<conditionDelimiterInArray>\?+)+?)",\s*"(?:(?:[^\?]|\k<conditionDelimiterInArray>\?+\[|\]\k<conditionDelimiterInArray>\?+)+?)"\]\k<conditionDelimiterInArray>(?!\?))|[^"])+?)",\s*"(?<joinParam>[^"]+)")\]|\$(?<conditionDelimiter>\?+)\[(?<conditionKey>[^\],]+),\s*"(?<testParam>[^"]+)",\s*"(?<trueParam>(?:[^\?]|\k<conditionDelimiter>\?+\[|\]\k<conditionDelimiter>\?+)+?)",\s*"(?<falseParam>(?:[^\?]|\k<conditionDelimiter>\?+\[|\]\k<conditionDelimiter>\?+)+?)"\]\k<conditionDelimiter>(?!\?)|\$\{(?<key>[^},]+)?\}/g,
        (match, arrayKey, mapParam, conditionDelimiterInArray, joinParam, conditionDelimiter, conditionKey, testParam, trueParam, falseParam, key) => {
            //If the captured item is composed, such as acquaintances, a mapping and joining treatment
            // is effected. This complexe procedure was selected to avoid the eval usage, too dangerous
            if (conditionKey) {
                const trimmedKey = conditionKey.trim();
                if (values.hasOwnProperty(trimmedKey)) {
                    return values[trimmedKey] === testParam ? interpolateTemplate(trueParam, values) : interpolateTemplate(falseParam, values);
                }
                else {
                    return '';
                }
            }
            //If the captured item is composed, such as acquaintances, a mapping and joining treatment
            // is effected. This complexe procedure was selected to avoid the eval usage, too dangerous
            else if (arrayKey) {
                const trimmedKey = arrayKey.trim();
                if (values.hasOwnProperty(trimmedKey)) {
                    return values[trimmedKey].map(item => interpolateTemplate(mapParam, item)).join(joinParam);
                }
                else {
                    return '';
                }
            }
            else if (key) {
                const trimmedKey = key.trim();
                if (values.hasOwnProperty(trimmedKey)) {
                    return values[trimmedKey];
                }
                else {
                    console.log(key, "Key not found");
                    return '';
                }
            }
            else { return ''; }
        });
}

const captureAndUploadThumbnail = async (storyId) => {
    if (!document.getElementsByClassName('app')[0]) return null;

    const canvas = await html2canvas(document.getElementsByClassName('app')[0]);
    const blob = await new Promise(resolve => canvas.toBlob(resolve));
    const options = {
        maxSizeMB: 1.5,
        maxWidthOrHeight: 1080,
        useWebWorker: true,
        initialQuality: 0.85, // Set initial quality to 85%
        convertSize: 500000, // Set maximum converted file size to 500 KB
        fileType: 'image/webp', // Convert to webp format
    };
    const compressedFile = await imageCompression(blob, options);
    const blobCompressed = new Blob([compressedFile], { type: 'image/webp' });

    const screenshotPath = `thumbnails/${storyId}/screenshot.png`;
    await uploadFileToAws(screenshotPath, blobCompressed);
    return getFileUrl(screenshotPath);
};
const convertToWebP = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                canvas.toBlob(
                    (blob) => {
                        const webpFile = new File([blob], 'thumbnail.webp', {
                            type: 'image/webp',
                        });
                        resolve(webpFile);
                    },
                    'image/webp',
                    0.8 // Adjust the WebP quality as needed (0 to 1)
                );
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    });
};
const UploadThumbnail = async (storyId, thumbnailFile) => {
    if (!thumbnailFile) return null;

    const oldScreenshotPath = `thumbnails/${storyId}/screenshot.png`;

    // Check if the file exists and delete it
    try {
        const files = await listFiles(`thumbnails/${storyId}/`);
        if (files.Contents && files.Contents.some(file => file.Key.includes('screenshot.png'))) {
            await deleteFile(oldScreenshotPath);
        }
    } catch (error) {
        // File doesn't exist, continue
    }

    // Compress the image
    const options = {
        maxSizeMB: 0.5, // Adjust the maximum file size as needed (in MB)
        maxWidthOrHeight: 480, // Adjust the maximum width or height as needed
        useWebWorker: true,
    };

    try {
        const compressedFile = await imageCompression(thumbnailFile, options);

        // Convert the compressed file to WebP format
        const webpFile = await convertToWebP(compressedFile);

        const thumbnailPath = `thumbnails/${storyId}/screenshot.webp`;
        await uploadFileToAws(thumbnailPath, webpFile);
        return getFileUrl(thumbnailPath);
    } catch (error) {
        console.error('Error compressing or converting the image:', error);
        // Handle the error as needed
    }
};
async function deleteFolder(folderPath) {
    try {
        const files = await listFiles(folderPath);

        if (files.Contents) {
            await Promise.all(files.Contents.map(file => deleteFile(file.Key)));
        }
    } catch (error) {
        console.error('Error deleting folder:', error);
    }
}
const UploadMusic = async (storyId, musicFile) => {
    if (!musicFile) return null;
    const musicPath = `musics/${storyId}/MainMusic.mp3`; // or the appropriate file type
    await uploadFileToAws(musicPath, musicFile);
    return getFileUrl(musicPath);
};

/**
 * Check and award daily tokens to user
 * @param {string} userId - User ID
 * @returns {Object|null} - Reward data for display, or null if no reward
 */
export const checkAndAwardTokens = async (userId) => {
    const userDocRef = doc(db, "users", userId);

    // Fetch user document
    const userSnapshot = await getDoc(userDocRef);

    // Get today's date without time
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayTimestamp = Timestamp.fromDate(today);

    if (userSnapshot.exists()) {
        const userData = userSnapshot.data();
        const lastVisit = userData.lastVisit?.toDate() || null;

        let tokensToAdd = 500; // Default for the first day
        let consecutiveDays = userData.consecutiveDays || 0;

        if (lastVisit) {
            const lastVisitDate = new Date(lastVisit);
            lastVisitDate.setHours(0, 0, 0, 0);

            const diffInDays = Math.floor((today - lastVisitDate) / (1000 * 60 * 60 * 24));

            if (diffInDays === 1) {
                // Consecutive day
                consecutiveDays += 1;
                if (consecutiveDays === 2) tokensToAdd = 600;
                else if (consecutiveDays === 3) tokensToAdd = 750;
                else if (consecutiveDays === 4) tokensToAdd = 900;
                else if (consecutiveDays === 5) tokensToAdd = 1000;
                else if (consecutiveDays === 6) tokensToAdd = 1200;
                else if (consecutiveDays >= 7) tokensToAdd = 1500;
            } else if (diffInDays > 1) {
                // Break in consecutive streak
                consecutiveDays = 1; // Reset streak
            } else {
                // Same day visit, no additional tokens
                return null;
            }
        } else {
            // First time visit
            consecutiveDays = 1;
        }

        const newTotalTokens = (userData.tokenCount || 0) + tokensToAdd;

        // Update user document
        await updateDoc(userDocRef, {
            tokenCount: newTotalTokens,
            lastVisit: todayTimestamp,
            consecutiveDays: consecutiveDays,
        });

        
        // Return reward data for UI display
        return {
            tokensAwarded: tokensToAdd,
            consecutiveDays: consecutiveDays,
            newTotal: newTotalTokens,
            isFirstTime: false
        };
    } else {
        // First time user, create document with welcome bonus
        const welcomeBonus = 3000;
        await setDoc(userDocRef, {
            tokenCount: welcomeBonus,
            lastVisit: todayTimestamp,
            consecutiveDays: 1,
        });
        // Return first-time reward data
        return {
            tokensAwarded: welcomeBonus,
            consecutiveDays: 1,
            newTotal: welcomeBonus,
            isFirstTime: true
        };
    }
};

const decrementTokenCount = async (userId, tokenAmount) => {
    try {
        if (userId === null) {
            localStorage.setItem('tokensNotConnected', parseInt(localStorage.getItem('tokensNotConnected')) - 10);
            return true;
        }
        const tokenDocRef = doc(db, 'users', userId.uid);
        const tokenDoc = await getDoc(tokenDocRef);
        if (tokenDoc.exists()) {
            const tokenCount = tokenDoc.data().tokenCount;
            if (tokenCount > 0) {
                await updateDoc(tokenDocRef, { tokenCount: tokenCount - tokenAmount });
                return true; // Return true on successful decrement
            } else {
                console.error('Token count is already 0');
                return false; // Return false if token count is already 0
            }
        } else {
            console.error('User document not found');
            return false; // Return false if user document not found
        }
    } catch (error) {
        console.error('Error decrementing token count:', error);
        return false; // Return false on error
    }
};


async function checkUserRegistration(uid) {
    const userRef = doc(db, 'users', uid);
    const docSnap = await getDoc(userRef);
    return docSnap.exists(); // Use exists() as a method
}
export function isContactMainCharacter(contact) {
    if (!contact) {
        return false;
    }
    return parseInt(contact.number) === 0
}

function QuestionPopup({ message }) {
    return (
        <Popup
            trigger={
                <Icon name='question circle' color='grey' style={{ marginLeft: '5px' }} />
            }
            content={message}
            on={['hover', 'click']}
            wide
            hoverable
        />
    )
}
const handleRessourcesComplexesFinal = async (file, story) => {
    const filePath = `RessourcesComplexes/${story.id}/${story.parameters.ressources_complexes.length + 1}`;
    await uploadFileToAws(filePath, file);
    const downloadURL = getFileUrl(filePath);

    const updatedRessourcesComplexes = [...story.parameters.ressources_complexes, downloadURL];
    story.setParameters({ ...story.parameters, ressources_complexes: updatedRessourcesComplexes });
    return downloadURL;
}

const handleRessourcesComplexes = async (e, story) => {
    if (!e || !e.target || !e.target.files) {
        return;
    }
    let latestFile;
    for (const file of e.target.files) {
        console.log("File uploaded:", file);
        latestFile = await handleRessourcesComplexesFinal(file, story);
        console.log("File uploaded:", latestFile);
    }
    return latestFile;
}

export function getDynamicTimeString(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const dateString = `${day}/${month}/${year} - ${hour}:${minute}:${seconds}`;
    return dateString;
}

// timeString can be either in format "4:34:56 PM" or "16:34:56". It will work in both cases.
export function convertSplittedDateToDate(date, timeString) {
    const parts = timeString.split(/[:, ]+/);
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    const seconds = parseInt(parts[2]);
    const isPM = parts[3] === "PM";

    const timeDate = new Date(date);
    timeDate.setHours(isPM ? hours + 12 : hours, minutes, seconds, 0);

    return timeDate;
}

function createDateFromValues(dateStr, timeStr) {
    if (!dateStr || !timeStr) {
        return new Date('Invalid Date');
    }

    // Parse time string
    let hours, minutes, seconds;
    const is12HourFormat = /(AM|PM)/i.test(timeStr);

    if (is12HourFormat) {
        const date = new Date(`1970-01-01 ${timeStr}`);
        hours = date.getHours();
        minutes = date.getMinutes();
        seconds = date.getSeconds();
    } else {
        const timeParts = timeStr.split(":").map(Number);
        hours = timeParts[0] || 0;
        minutes = timeParts[1] || 0;
        seconds = timeParts[2] || 0;
    }

    // Parse date string
    let normalizedDate;
    if (/\d{4}-\d{2}-\d{2}/.test(dateStr)) {
        normalizedDate = dateStr; // Already YYYY-MM-DD format
    } else if (/\d{2}\/\d{2}\/\d{4}/.test(dateStr)) {
        const [part1, part2, part3] = dateStr.split("/");
        if (part3.length === 4) {
            normalizedDate = `${part3}-${part2}-${part1}`; // Assuming DD/MM/YYYY format
        }
    } else {
        return new Date('Invalid Date');
    }

    // Create final date object
    const finalDate = new Date(`${normalizedDate}T${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`);
    return finalDate;
}

export function splitNarrativeMessage(message) {
    if (!message) {
        return null;
    }

    // Expression régulière pour capturer les narrations et les dialogues selon le nouveau format
    const regex = /(\§-(.+?)(?=\§\*|\n|$)|\§\*(.*?)\s*:\s*(.*?)(?=\n|$))/gs;

    const result = [];
    let lastIndex = 0;
    let narrativeMessage = null;
    let hasMatches = false;

    // Process all matches and capture uncaptured text inline
    while (true) {
        const match = regex.exec(message);

        // If there's text before this match (or end of string), treat it as narrative
        if (match === null || match.index > lastIndex) {
            const uncapturedText = message.substring(lastIndex, match ? match.index : message.length).trim();
            if (uncapturedText) {
                if (!narrativeMessage) {
                    narrativeMessage = {
                        senders: ['narration'],
                        receivers: ['0'],
                        message: `§-${uncapturedText}`,
                    };
                    result.push(narrativeMessage);
                } else {
                    narrativeMessage.message += `\n${uncapturedText}`;
                }
            }
        }

        if (match === null) break;

        hasMatches = true;
        lastIndex = regex.lastIndex;

        if (match[3] && match[4]) {
            // Dialogue format: §*utilisateur: message
            const sender = match[3].trim();
            const messageText = match[4].trim();
            result.push({
                senders: [sender],
                receivers: ['0'],
                message: messageText,
            });
            narrativeMessage = null;
        } else if (match[2]) {
            // Narrative format: §-message
            const narrative = match[2].trim();
            if (!narrativeMessage) {
                narrativeMessage = {
                    senders: ['narration'],
                    receivers: ['0'],
                    message: `§-${narrative}`,
                };
                result.push(narrativeMessage);
            } else {
                narrativeMessage.message += `\n${narrative}`;
            }
        }
    }

    // If no matches were found at all, treat the whole message as narrative
    if (!hasMatches && result.length === 0) {
        result.push({
            senders: ['narration'],
            receivers: ['0'],
            message: `§-${message.trim()}`,
        });
    }

    return result;
}

export function isTWA() {
    let isAndroidTwaSession;
    if (document.referrer.includes('android-app://fr.fablia.twa')) {
        isAndroidTwaSession = true;
        sessionStorage.setItem('has_android_twa_referrer', 'yes');
    } else {
        isAndroidTwaSession = sessionStorage.getItem('has_android_twa_referrer') === 'yes';
    }
}

export { handleRessourcesComplexesFinal, handleRessourcesComplexes, UploadThumbnail, UploadMusic, deleteFolder, interpolateTemplate, updateUserTokenCount, checkUserRegistration, decrementTokenCount, captureAndUploadThumbnail, QuestionPopup, createDateFromValues };
